import React, { useState } from 'react';
import './InventoryTable.css';
import InventoryModel from './InventoryModel';
import apiService from '../api/apiService';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Pagination from './Pagination/Pagination';
import ConfirmDeleteModal from './ConfirmDeleteModal';
import EditInventoryModal from './EditInventoryModal';

const InventoryTable = ({ data, setData, hotelId }) => {
  const [editingItem, setEditingItem] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState({
    isOpen: false,
    id: null,
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(10);
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = Array.isArray(data)
    ? data.slice(indexOfFirstRow, indexOfLastRow)
    : [];
  const totalPages = Math.max(Math.ceil(data.length / rowsPerPage), 1);

  const confirmDelete = id => {
    if (!id) return;
    setDeleteConfirm({ isOpen: true, id });
  };
  // Handle Edit Button Click (Opens Modal)
  const handleEditClick = item => {
    setEditingItem(item);
    setIsModalOpen(true);
  };

  // Handle Save from Modal
  const handleEdit = updatedItem => {
    setData(prevData =>
      prevData.map(item => (item.id === updatedItem.id ? updatedItem : item))
    );
    setIsModalOpen(false);
    setEditingItem(null);
  };

  const handleDelete = async () => {
    try {
      const response = await apiService.delete(
        `/inventory/${deleteConfirm.id}/?hotel=${hotelId}`
      );
      toast.error('Inventory deleted successfully!');
      setData(prevData =>
        prevData.filter(item => item.id !== deleteConfirm.id)
      );
    } catch (err) {
      console.log(err);
      toast.failed('Failed to delete inventory!');
    } finally {
      setDeleteConfirm({ isOpen: false });
    }
  };

  return (
    <>
      <div className="invent-table-container" style={{ minHeight: '300px' }}>
        <table className="invent-table">
          <thead>
            <tr>
              <th>Item ID</th>
              <th>Item Name</th>
              <th>Quantity</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.length > 0 ? (
              data.map(item => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>{item.item_name}</td>
                  <td>{item.quantity}</td>
                  <td>
                    <div className="options-menu">
                      <button className="options-button">⋮</button>
                      <div className="dropdown-menu">
                        <button onClick={() => handleEditClick(item)}>
                          Edit
                        </button>
                        <button onClick={() => confirmDelete(item.id)}>
                          Delete
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7">No data available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <>
        {isModalOpen && (
          <EditInventoryModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            onSave={handleEdit}
            existingData={editingItem}
            hotelId={hotelId}
          />
        )}

        <ConfirmDeleteModal
          isOpen={deleteConfirm.isOpen}
          onConfirm={handleDelete}
          onCancel={() => setDeleteConfirm({ isOpen: false, id: null })}
          message="Are you sure you want to delete this item?"
        />

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />
      </>
    </>
  );
};

export default InventoryTable;
